import React, { useState } from 'react';
import api from '../services/api';

export default function ChangePasswordForm({ userId }) {
  const [formData, setFormData] = useState({ oldPass: '', newPass: '', confirmPass: '' });
  const [status, setStatus] = useState({ type: '', msg: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.newPass !== formData.confirmPass) {
      return setStatus({ type: 'error', msg: '❌ Las nuevas contraseñas no coinciden' });
    }
    setLoading(true);
    setStatus({ type: '', msg: '' });

    try {
      await api.post('/users/change-password', {
        userId,
        oldPass: formData.oldPass,
        newPass: formData.newPass
      });
      setStatus({ type: 'success', msg: '✅ ¡Contraseña actualizada con éxito!' });
      setFormData({ oldPass: '', newPass: '', confirmPass: '' });
    } catch (err) {
      setStatus({ type: 'error', msg: `❌ ${err.response?.data?.message || 'Error al actualizar'}` });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-100 max-w-md mx-auto">
      <h3 className="text-xl font-bold text-gray-800 mb-4">Seguridad de Cuenta</h3>
      
      {status.msg && (
        <div className={`p-3 mb-4 rounded-xl text-sm font-medium border ${
          status.type === 'success' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200'
        }`}>
          {status.msg}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="password"
          placeholder="Contraseña Actual"
          className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
          value={formData.oldPass}
          onChange={(e) => setFormData({...formData, oldPass: e.target.value})}
          required
        />
        <input
          type="password"
          placeholder="Nueva Contraseña"
          className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
          value={formData.newPass}
          onChange={(e) => setFormData({...formData, newPass: e.target.value})}
          required
        />
        <input
          type="password"
          placeholder="Confirmar Nueva Contraseña"
          className="w-full px-4 py-3 border rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
          value={formData.confirmPass}
          onChange={(e) => setFormData({...formData, confirmPass: e.target.value})}
          required
        />
        <button
          disabled={loading}
          className="w-full bg-indigo-600 text-white py-3 rounded-xl font-bold hover:bg-indigo-700 disabled:bg-gray-400 transition"
        >
          {loading ? 'Actualizando...' : 'Cambiar Contraseña'}
        </button>
      </form>
    </div>
  );
}